import React, { useState, useEffect } from "react";
import { adminCreateShippingFee, adminUpdateShippingFee } from "../api/admin";
import { toast } from "react-toastify";

const ShippingForm = ({ fee, onSuccess, onCancel }) => {
  // Use empty strings / default values to avoid undefined errors
  const [state, setState] = useState("");
  const [comboFee, setComboFee] = useState("");
  const [deliveryFee, setDeliveryFee] = useState("");
  const [above500Fee, setAbove500Fee] = useState("");

  // Populate form if editing
  useEffect(() => {
    if (fee) {
      setState(fee.state || "");
      setComboFee(fee.combo_fee ?? "");
      setDeliveryFee(fee.delivery_fee ?? "");
      setAbove500Fee(fee.above_500_fee ?? "");
    } else {
      setState("");
      setComboFee("");
      setDeliveryFee("");
      setAbove500Fee("");
    }
  }, [fee]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      state,
      combo_fee: Number(comboFee) || 0,
      delivery_fee: Number(deliveryFee) || 0,
      above_500_fee: Number(above500Fee) || 0,
    };

    try {
      const feeId = fee?._id || fee?.id || fee?.shipping_id;
      if (feeId) {
        await adminUpdateShippingFee(feeId, data);
        toast.success("Shipping fee updated successfully! ✨");
      } else {
        await adminCreateShippingFee(data);
        toast.success("Shipping fee created successfully! 🚚");
      }
      onSuccess();
      setState(""); setComboFee(""); setDeliveryFee(""); setAbove500Fee("");
    } catch (err) {
      console.error("Error saving shipping fee:", err);
      toast.error(err.response?.data?.message || "Failed to save shipping fee. ❌");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="admin-form">
      <div className="form-body">
        <div className="form-grid">
          <div className="form-group">
            <label>State <span className="required-star">*</span></label>
            <input
              type="text"
              value={state}
              onChange={(e) => setState(e.target.value)}
              placeholder="e.g., TamilNadu"
              required
            />
          </div>

          <div className="form-group">
            <label>Combo Fee (₹) <span className="required-star">*</span></label>
            <input
              type="number"
              value={comboFee}
              onChange={(e) => setComboFee(e.target.value)}
              placeholder="0"
              required
            />
          </div>

          <div className="form-group">
            <label>Delivery Fee (₹) <span className="required-star">*</span></label>
            <input
              type="number"
              value={deliveryFee}
              onChange={(e) => setDeliveryFee(e.target.value)}
              placeholder="0"
              required
            />
          </div>

          <div className="form-group">
            <label>Above ₹500 Fee (₹) <span className="required-star">*</span></label>
            <input
              type="number"
              value={above500Fee}
              onChange={(e) => setAbove500Fee(e.target.value)}
              placeholder="0"
              required
            />
          </div>
        </div>
        <div className="form-footer">
          <button type="submit" className="btn-submit">
            {fee ? "Update Fee" : "Save Shipping Fee"}
          </button>
          <button
            type="button"
            className="btn-cancel"
            onClick={() => {
              setState(""); setComboFee(""); setDeliveryFee(""); setAbove500Fee("");
              onCancel?.();
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
  );
};

export default ShippingForm;
